module.exports = __webpack_public_path__ + "img/nerd.6f9823d9.png";